import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import { getContactusList } from '@/services/customer/erpCustomerList';
export default {
  name: 'contact-us',
  components: {},
  i18n: require('./i18n-customer'),
  data: function data() {
    var _this = this;
    return {
      sendTime: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_this.$t('public.total'), "\uFF1A").concat(total);
        },
        current: 1,
        pageSize: 20,
        total: 0
      },
      total: 0,
      dataList: [],
      isTableLoading: false,
      columns: [
      //姓名/身份
      {
        dataIndex: 'nameIdentity',
        slots: {
          title: 'customTitle'
        },
        scopedSlots: {
          customRender: 'custom' //自定义表格里面的内容
        },
        key: 'nameIdentity',
        width: '12%'
      },
      //邮箱/联系电话
      {
        dataIndex: 'emailphone',
        slots: {
          title: 'customTitle2'
        },
        scopedSlots: {
          customRender: 'custom2' //自定义表格里面的内容
        },
        key: 'emailphone',
        width: '15%'
      },
      //地区/邮编
      {
        dataIndex: 'countryAddresspost',
        slots: {
          title: 'customTitle3'
        },
        scopedSlots: {
          customRender: 'custom3' //自定义表格里面的内容
        },
        key: 'countryAddresspost',
        width: '12%'
      },
      //详细地址
      {
        title: this.$t('contactUs.addressDetail'),
        dataIndex: 'addressDetail',
        key: 'addressDetail',
        width: '15%'
      },
      //公司名称
      {
        title: this.$t('contactUs.companyName'),
        dataIndex: 'companyName',
        key: 'companyName',
        width: '12%'
      },
      //咨询类型
      {
        title: this.$t('contactUs.consultationType'),
        dataIndex: 'consultationType',
        key: 'consultationType',
        scopedSlots: {
          customRender: 'consultationType' //自定义表格里面的内容
        },
        width: '12%'
      },
      //咨询/反馈内容
      {
        title: this.$t('contactUs.consultationContent'),
        dataIndex: 'consultationContent',
        key: 'consultationContent',
        scopedSlots: {
          customRender: 'consultationContent'
        },
        ellipsis: true,
        width: '16%'
      },
      // 查询时间
      {
        title: this.$t('contactUs.createTime'),
        dataIndex: 'createTime',
        key: 'createTime',
        scopedSlots: {
          customRender: 'createTime'
        },
        width: '100px'
      }]
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    //加载列表数据
    loadData: function loadData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.isTableLoading = true;
              _context.n = 1;
              return getContactusList(_this2.pagination.current, _this2.pagination.pageSize);
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                _this2.pagination.total = res.data.data.totalNum;
                _this2.dataList = res.data.data.list;
                _this2.isTableLoading = false;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    changePage: function changePage(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.loadData();
    },
    showSizeChange: function showSizeChange(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.loadData();
    },
    formatTimestamp: function formatTimestamp(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0');
      var day = date.getDate().toString().padStart(2, '0');
      var hours = date.getHours().toString().padStart(2, '0');
      var minutes = date.getMinutes().toString().padStart(2, '0');
      var seconds = date.getSeconds().toString().padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};